import React, { useMemo } from 'react';
import { Col, Row } from 'antd';
import { groupDamagesByImageFileId } from '../../../utils/damageGrouping';
import DamageCard, { type DamageItem } from './DamageCard';
import type { InspectionMediaData, InspectionMediaType } from '../inspectionMediaTypes';

type DamageListProps = {
  viewName: string;
  damages: DamageItem[];
  handleItemClick?: (item?: InspectionMediaData, type?: InspectionMediaType) => void;
  isMobileInspection?: boolean;
};

const EmptyDamageState = () => (
  <Col span={24}>
    <div className="text-center text-gray-400 py-10">There were no damages found for this view</div>
  </Col>
);

const DamageList: React.FC<DamageListProps> = ({ viewName, damages, handleItemClick, isMobileInspection = false }) => {
  const groupedDamages = useMemo(() => groupDamagesByImageFileId(damages), [damages]);

  if (!groupedDamages.length) {
    return <EmptyDamageState />;
  }

  return (
    <Row gutter={[8, 8]}>
      {groupedDamages.map(group => (
        <DamageCard
          key={group.imageFileGroupKey}
          group={group}
          viewName={viewName}
          isMobileInspection={isMobileInspection}
          onItemClick={handleItemClick}
        />
      ))}
    </Row>
  );
};

export default DamageList;
